import React from 'react'
import { postData } from '../global/Globalapi'
import { useRef, useEffect } from 'react';

const S_Partner_For = ({ closeModal, Existingdata, data }) => {
  const dnameRef = useRef(null);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const trackingRef = useRef(null);
  // Support both prop names: `Existingdata` (older) and `data` (Shipping passes `data={Existingdata}`)
  const existing = Existingdata || data || null;
  let ExistingId = null;

  useEffect(() => {
    if (existing) {
      ExistingId = existing.delivery_partner_id;
      if (dnameRef.current) dnameRef.current.value = existing.delivery_partner_name || '';
      if (nameRef.current) nameRef.current.value = existing.contact_person_name || '';
      if (phoneRef.current) phoneRef.current.value = existing.phone_no || '';
      if (trackingRef.current) trackingRef.current.value = existing.tracking_id || '';
    }
  }, [existing]);


    async function  addNewPartner(){
      const payload = {
        delivery_partner_name: document.getElementById('partner_name').value,
        contact_person_name: document.getElementById('person_name').value,
        phone_no: document.getElementById('phone_no').value,
        tracking_id: document.getElementById('tracking_id').value,
        status: 'active'
      }

      console.log('Submitting payload', payload);


      const res = await postData('/shipment/add-new-partner', payload);

      console.log(res);

      if(res && res.status === 200){
        alert('New Delivery Partner Added Successfully');
        
        document.getElementById('partner_name').value = '';
        document.getElementById('person_name').value = '';
        document.getElementById('phone_no').value = '';
        document.getElementById('tracking_id').value = '';
       
        closeModal();
      } else {
        alert('Error Adding New Delivery Partner');
      }
    }

  return (
  <div className="fixed inset-0 backdrop-blur-sm bg-black/40 flex items-center justify-center z-50">
    <div className="relative w-[520px] bg-white dark:bg-gray-800 text-black dark:text-white p-10 rounded-2xl shadow-2xl border border-gray-200/30 dark:border-gray-600/40">

      {/* Close Button */}
      <button
        onClick={closeModal}
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 dark:hover:text-white text-3xl font-bold"
        aria-label="Close"
      >
        ×
      </button>


      <h1 className="text-2xl font-bold text-center mb-2 tracking-wide">
        Add Delivery Partner
      </h1>
      <p className="text-center text-black dark:text-gray-300 mb-8 text-sm">
        Enter partner details below
      </p>

<hr className='m-3'></hr>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          addNewPartner();
        }}
        className="grid grid-cols-[180px_1fr] gap-y-6 gap-x-4 mt-[10%]"
      >

        <label htmlFor="partner_name" className="font-medium self-center text-sm text-black dark:text-gray-300">
          Partner Name
        </label>
        <input
          id="partner_name"
          ref={dnameRef}
          placeholder="Ex: Delivro Pvt Ltd"
          className="border border-gray-300 dark:text-white dark:border-gray-600 bg-gray-50 dark:bg-gray-700 px-3 h-10 rounded-lg focus:ring-2 focus:ring-black/40 dark:focus:ring-white/40 outline-none"
        />

        <label htmlFor="person_name" className="font-medium self-center text-sm text-black dark:text-gray-300">
          Contact Person
        </label>
        <input
          id="person_name"
          ref={nameRef}
          placeholder="Ex: Ramesh Kumar"
          className="border border-gray-300 dark:text-white dark:border-gray-600 bg-gray-50 dark:bg-gray-700 px-3 h-10 rounded-lg focus:ring-2 focus:ring-black/40 dark:focus:ring-white/40 outline-none"
        />

        <label htmlFor="phone_no" className="font-medium self-center text-sm text-black dark:text-gray-300">
          Phone Number
        </label>
        <input
          id="phone_no"
          ref={phoneRef}
          placeholder="+91 XXXXX XXXXX"
          className="border border-gray-300 dark:text-white dark:border-gray-600 bg-gray-50 dark:bg-gray-700 px-3 h-10 rounded-lg focus:ring-2 focus:ring-black/40 dark:focus:ring-white/40 outline-none"
        />

        <label htmlFor="tracking_id" className="font-medium self-center text-sm text-black dark:text-gray-300">
          Tracking ID
        </label>
        <input
          id="tracking_id"
          ref={trackingRef}
          placeholder="Ex: TRK12345"
          className="border border-gray-300 dark:text-white dark:border-gray-600 bg-gray-50 dark:bg-gray-700 px-3 h-10 rounded-lg focus:ring-2 focus:ring-black/40 dark:focus:ring-white/40 outline-none"
        />

        <div></div>
        <button
          type="submit"
          className="mt-4 bg-red-500 text-white dark:text-black px-6 py-2 rounded-xl text-sm font-semibold hover:scale-[1.03] transition-transform shadow-sm"
        >
          Add/Update Partner
        </button>
      </form>
    </div>
  </div>
);

}

export default S_Partner_For
